import module from 'module';
import _ from 'lodash';

import templateUrl from './dictionary-condition.template.html';
import './dictionary-condition.style.less';

class DictionaryConditionComponent {
  constructor($scope, dict) {
    this.$scope = $scope;
    this.dict = dict;
  }

  $onInit() {
    this.type = 'DICTIONARY';

    this.dict.onLoadingComplete(() =>
      this.dictionaryEntries = this.dict[this.propertyDefinition.code]
    );

    this.$scope.$watchCollection('$ctrl.conditions', () => {
      if (!this.propertyDefinition) {
        return;
      }

      if (!this.isConditionAlreadyDefined()) {
        this.setDefaultValues();
      } else {
        this.fetchExistingValues();
      }
    });

    this.valueChanged = () => {
      this.saveValues();
    };
  }

  setDefaultValues() {
    this.model = {param: null};
  }

  fetchExistingValues() {
    this.model = this.conditions[this.propertyDefinition.property].model;
  }

  /**
   * Gets the only one allowed predicate for this type
   *
   * @returns {*}
   */
  getSupportedPredicate() {
    return this.propertyDefinition.supportedPredicates[0];
  }

  saveValues() {
    this.conditions[this.propertyDefinition.property] = {
      properties: [this.propertyDefinition.property],
      type: this.propertyDefinition.type,
      code: this.propertyDefinition.code,
      model: this.model,
      predicate: this.getSupportedPredicate()
    };
  }

  isConditionAlreadyDefined() {
    return _.has(this.conditions, this.propertyDefinition.property);
  }
}

module.component('dictionaryCondition', {
  templateUrl,
  bindings: {
    conditions: '=',
    propertyDefinition: '<'
  },
  controller: DictionaryConditionComponent
});
